import { KeycloakConfig } from 'keycloak-js';
import { environment } from '../environments/environment';

export const keycloakConfig: KeycloakConfig = {
  url: environment.keycloakUrl,
  realm: environment.keycloakRealm,
  clientId: environment.keycloakClient,
};
